import { getMyNetworkingByKey } from '../myNetworkingSelectors';
import { PIN_BOARD_ID_KEY, PIN_BOARD_KEY } from './pinboardConstants';

export const getPinboard = () => getMyNetworkingByKey(PIN_BOARD_KEY);
export const getPinboardId = () => getMyNetworkingByKey(PIN_BOARD_ID_KEY);

export const isPinboardPost = (post) => post?.commenttype === 'Newsfeed';
